import { studentRequests } from "api/studentApi";
import { Button, FormDataConsumer, ImageField, ImageInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import { Grid } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import Edit from "@mui/icons-material/Edit";

import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const DOCUMENT_SIDES = [
  {
    id: 0,
    name: "Снимка на документ за самоличност - предна част",
    fileSource: "frontFile",
  },
  {
    id: 1,
    name: "Снимка на документ за самоличност - гръб",
    fileSource: "backFile",
  },
];

const validateFile = value => {
  if (!value) {
    return "Прикачете снимка във формат: jpeg, png, pdf";
  }

  const validTypes = ["image/jpeg", "image/png", "application/pdf"];

  const file = value?.rawFile;

  if (file && !validTypes.includes(file.type)) {
    return "Позволени формати за прикачване: jpeg, png, pdf";
  }

  return undefined;
};

const AddPersonalDocumentsPhotoModal = ({ studentId, id, fetchData }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();

  const handleSubmit = async (file, side) => {
    if (!file) {
      notify("Моля прикачете файл", { type: "warning" });
      return;
    }

    try {
      await dataProvider.customRequest(
        studentRequests.createStudentPersonalDocuments({
          studentId,
          documentId: id,
        }),
        {
          File: file,
          Side: side,
        },
        "POST",
        null,
        true,
      );

      fetchData();
      notify("Успешно прикачен документ", {
        type: "success",
      });
    } catch (e) {
      notifyError(e);
    }
  };

  return (
    <FormModal
      titleContent="Редакция на документи за самоличност"
      hideSaveButton={true}
      triggerButton={
        <Button
          label="Редакция на документ"
          variant="contained"
          startIcon={<Edit />}
          sx={{ width: "max-content" }}
        />
      }
    >
      <FormDataConsumer>
        {({ formData }) => (
          <Grid
            container
            spacing={3}
            p={2}
          >
            {DOCUMENT_SIDES.map(document => (
              <Grid
                container
                item
                spacing={2}
                key={document.id}
                alignItems="center"
              >
                <Grid
                  item
                  xs={12}
                  md={10}
                >
                  <ImageInput
                    source={document.fileSource}
                    label={document.name}
                    validate={validateFile}
                  >
                    <ImageField
                      source="src"
                      title="title"
                    />
                  </ImageInput>
                </Grid>

                <SecuredComponent permission={permissions.canManageStudentPrersonalDocuments}>
                  <Grid
                    item
                    xs={12}
                    md={2}
                  >
                    <Button
                      variant="contained"
                      label="Запази"
                      startIcon={<SaveIcon />}
                      onClick={() => handleSubmit(formData?.[document.fileSource], document.id)}
                    />
                  </Grid>
                </SecuredComponent>
              </Grid>
            ))}
          </Grid>
        )}
      </FormDataConsumer>
    </FormModal>
  );
};

export default AddPersonalDocumentsPhotoModal;
